import React from 'react'
import Nav from 'react-bootstrap/Nav'
import Navbar from 'react-bootstrap/Navbar'
import NavDropdown from 'react-bootstrap/NavDropdown'
import Container from 'react-bootstrap/Container'
import Button from 'react-bootstrap/Button'
import customRequest from '../../helpers/customRequest'
import redirect from '../redirect/redirect'
import message from '../message/message'
import readabilityPDF from '../../content/files/readability-of-stories.pdf'
import logo from '../../content/images/logo.svg'

class DefautlNavbar extends React.Component {

    render() {
        return (<Navbar bg="light" className="fixed-top hidden-print px-1 py-0 " expand="md">
            <Container fluid="xl">
                <Navbar.Brand className="mx-2">
                    <Nav.Link href={this.props.homeURL} onClick={() => {
                        window.scrollTo(0, 0) //Lisa wants to be able to scroll to top instantly
                    }}>
                        <img
                            src={logo}
                            alt="Logo"
                            title="Home"
                            className='py-1'
                        />
                    </Nav.Link>
                </Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav"/>
                <Navbar.Collapse className="" id="basic-navbar-nav">
                    <Nav className="m-auto">
                        {this.props.auth.includes("student") ?
                            <Nav.Link href="/student/dashboard" className='px-2'>Exercises</Nav.Link>
                            : ""
                        }
                        {this.props.auth.includes("customer") ?
                            <Nav.Link href="/students" className='px-2'>Students</Nav.Link>
                            : ""
                        }
                        <Nav.Link href="https://tutoring.greatleaps.com/" className='px-2'>Find A Tutor</Nav.Link>
                        {!this.props.auth.includes("student") ?
                            <Nav.Link className="px-2" href="/subscribe">Pricing</Nav.Link>
                            : ""
                        }
                        {this.props.auth.includes("customer") ?
                            <Nav.Link className="nav-link" href="/account/information">Account</Nav.Link>
                            : ""
                        }
                        {!this.props.auth.includes("student") ?
                            <NavDropdown title="Learn More" id="about-dropdown" className='px-2'>
                                <NavDropdown.Item className="" href="/about/the-program">The Program</NavDropdown.Item>
                                <NavDropdown.Item className="" href="/about/testimonials">Testimonials</NavDropdown.Item>
                                <NavDropdown.Item className="" href="/about/research">Research</NavDropdown.Item>
                                <NavDropdown.Item className="" href="/about/use-cases">Use Cases</NavDropdown.Item>
                                <NavDropdown.Item className="" href="/about/our-story">Our Story</NavDropdown.Item>
                            </NavDropdown>
                            : ""
                        }
                        <NavDropdown title="Resouces" id="resources-dropdown" className='px-2'>
                            {!this.props.auth.includes("student") ? <NavDropdown.Item  className="" href={"/file/instructions"} target="_blank" rel="noreferrer">Instructions</NavDropdown.Item > : ""}
                            {!this.props.auth.includes("student") ? <NavDropdown.Item className="" href="/help/frequently-asked-questions">FAQ</NavDropdown.Item> : ""}
                            {!this.props.auth.includes("student") ? <NavDropdown.Item  className="" href={readabilityPDF} target="_blank" rel="noopener noreferrer">Readability of Stories</NavDropdown.Item > : ""}
                            <NavDropdown.Item className="" href="https://greatleaps.com/index.php?main_page=contact_us" target="_blank" rel="noopener noreferrer">Customer Support</NavDropdown.Item>
                            {this.props.auth.includes("guest") ? <NavDropdown.Item className="" href="/account/recover">Account Recovery</NavDropdown.Item> : ""}
                        </NavDropdown>
                    </Nav>
                    <div className="d-flex justify-content-center">
                        {this.props.auth.includes("guest") && <>
                                <Nav.Link className="btn btn-success mx-2 px-2 py-1" href="/account/sign-up">Sign Up</Nav.Link>
                                <Nav.Link id="log-in-button" className="btn btn-outline-success mx-2 px-2 py-1" href="/account/log-in/teacher">Log In</Nav.Link>
                            </>
                        }
                    </div>
                </Navbar.Collapse>
                {!this.props.auth.includes("guest") &&
                    <form id="log-out-form" className="prevent-next-submit" noValidate method="post" action="/log-out" onSubmit={(event) => {
                        event.preventDefault()
                        customRequest.post("/api/logout").then(() => {
                                this.props.updatePermissions()
                                    .then(() => {
                                        redirect.send("/", this.props, () => {
                                            message.success("You have successfully logged out.")
                                        })
                                    })
                            })
                    }}>
                        <Button type="submit" variant='success' className="navbar-btn">Log Out</Button>
                    </form>
                }
            </Container>
        </Navbar>)
    }
}

export default DefautlNavbar
